import { useCallback } from 'react';
import { useBriefSubmittedMutation, useSubmitRequestMutation } from '../../graph';
import { OrphanedBriefError } from '../../lib/errors';
import { BriefType } from './useHandleSubmit';

export const useCartlessSubmit = () => {
    const [submitRequest] = useSubmitRequestMutation(); // Cartless submission for Upload & Go
    const [briefSubmittedMutation] = useBriefSubmittedMutation(); // Cartless submission for everything else.

    return useCallback(
        async (data: BriefType): Promise<string> => {
            if (!data.request || !data.request.facts)
                throw new OrphanedBriefError(
                    `Encountered orphaned brief in useCartlessSubmit hook: ${data.id}`
                );

            const {
                id,
                facts: { workflow },
            } = data.request;

            const { data: res, errors } =
                workflow !== 'CARE_EXPRESS'
                    ? await briefSubmittedMutation({
                          variables: { requestId: id, briefId: data.id },
                      })
                    : await submitRequest({ variables: { requestId: id } }); // Use the deprecated submit request mutation for Upload & Go

            if (errors && errors.length > 0) {
                throw new Error(
                    `useCartlessSubmission mutation failed: ${errors
                        .map((e) => e.message)
                        .join('; ')}`
                );
            }

            if (!res) throw new Error(`useCartlessSubmit: Failed to call to requests`);

            const next =
                'addEvent_BriefSubmitted' in res
                    ? res.addEvent_BriefSubmitted.facts?.currentUrl
                    : res.submitRequest.facts?.currentUrl;

            if (!next)
                throw new Error(`useCartlessSubmit: response did not return a redirect route`);

            return next;
        },
        [briefSubmittedMutation, submitRequest]
    );
};
